import React, { useState, useEffect, useContext, useRef } from "react";
import auth from "services/auth";
import ls from "local-storage";
import AppContext from "contexts/AppContext";
import api from "services/api";
import emailValidate from "services/emailValidate";
import {
  Modal,
  Button,
  Alert,
  Dropdown,
  Form,
  Overlay,
  Tooltip,
  Collapse,
  Accordion,
} from "react-bootstrap";
import {
  Redirect,
  Route,
  Link,
  useParams,
  useHistory,
  useLocation,
} from "react-router-dom";
// custom component
import LeftSidebar from "elements/LeftSidebar";
import RightSidebar from "elements/RightSidebar";
import CashierModals from "elements/dashboard_elements/CashierModals";
import VaultModals from "elements/dashboard_elements/VaultModals";
import LoginReg from "elements/LoginReg";
import LanguageSwitcher from "elements/LanguageSwitcher";
import BalanceTransfer from "elements/dashboard_elements/BalanceTransfer";
import PlayerStats from "elements/PlayerStats";
import Translator, { __ } from "services/Translator";
import SearchBox from "./SearchBox";
import UserDropDownMenu from "elements/UserDropDownMenu";

const Header = (props) => {
  // const menuOpen = props.menuOpen;
  const params = useParams();
  const history = useHistory();
  const location = useLocation();
  const { updateUserObj } = useContext(AppContext);
  const gamesCategory = params.category;

  const isAuthenticated = props.isAuthenticated;
  const userBalance = props.userBalance;
  const getUserBalance = props.getUserBalance;

  const logout = async (ev) => {
    ev.preventDefault();
    await auth.logout();
    await updateUserObj();
  };

  const notificationCount = props.notificationCount;

  // userMenu
  const [rightSidebarOpen, setRightSidebarOpen] = useState(false);
  const toggleRightSidebar = () => {
    setRightSidebarOpen(!rightSidebarOpen);
  };

  const [leftSidebarOpen, setLeftSidebarOpen] = useState(false);

  const [searchStr, setSearchStr] = useState("");
  const [searchSuggestions, setSearchSuggestions] = useState([]);
  const searchTextBox = useRef(null);

  // expand searcbar
  const [expandSearchBar, setExpandSearchBar] = useState(false);

  const toggleExpandedSearchBar = (force) => {
    if (expandSearchBar) {
      setSearchSuggestions([]);
      if (force === true) {
        setSearchStr("");
        setExpandSearchBar(false);
      } else {
        if (searchStr.length === 0) {
          setExpandSearchBar(false);
        }
      }
    } else {
      setExpandSearchBar(true);
      searchTextBox.current.focus();
    }
  };

  const getSearchSuggestions = async () => {
    if (searchStr.length >= 2) {
      var response = await api.get("/games/search-suggestions", {
        query: searchStr,
        providers: props.selectedProviders,
        extensiveInfo: true,
      });
      if (response.status === 200) {
        setSearchSuggestions(response.data);
      }
    } else {
      setSearchSuggestions([]);
    }
  };

  useEffect(() => {
    getSearchSuggestions();
  }, [searchStr]);

  const doSearchByGameName = (text) => {
    props.setSearchStr(text);
    toggleExpandedSearchBar(true);
    history.push("/games/search");
  };

  //GamePlay Page detection

  const [showInPlay, setShowInPlay] = useState(false);
  const playPath = location.pathname.split("/");

  useEffect(() => {
    setShowInPlay(playPath.includes("play"));
  }, [playPath]);

  const [fontSize, setFontSize] = useState(16);
  useEffect(() => {
    if (props.isAuthenticated) {
      if (props.userDetails.username.length > 10) {
        setFontSize(14);
      } else if (props.userDetails.username.length > 14) {
        setFontSize(12);
      }
    }
  }, [props]);

  // const [modalSignUpPropsData, setModalSignUpPropsData] = useState(false);
  // const [modalLoginPropsData, setModalLoginPropsData] = useState(false);
  const [shrink, setShrink] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > 0) {
        setShrink(true);
      } else {
        setShrink(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <>
      <LoginReg {...props} />
      <header
        className={
          (showInPlay ? "inPlay " : " ") + (shrink ? "resizedHeader" : " ")
        }
      >
        {/* version 1 */}
        <section
          className={"header  " + (isAuthenticated ? " authenticated" : "")}
        >
          <div className="container-fluid">
            <div className="header_menu_v1">
              <div className="d-none d-md-inline-block desktop_menu_icon_and_search">
                <div className="d-none item d-md-inline-block">
                  {!props.showLeftSidebar && (
                    <Link
                      onClick={() => {
                        props.setShowLeftSidebar(true);
                      }}
                      className="bar_icon"
                    >
                      <svg
                        width="41"
                        height="32"
                        viewBox="0 0 41 45"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M37.925 0.625H3.075C1.37634 0.625 0 2.00134 0 3.7C0 5.39865 1.37634 6.775 3.075 6.775H37.925C39.6236 6.775 41 5.39865 41 3.7C41 2.00134 39.6236 0.625 37.925 0.625Z"
                          fill="#45CAFE"
                        />
                        <path
                          d="M32.1163 12.925H3.075C1.37634 12.925 0 14.3013 0 16C0 17.6986 1.37634 19.075 3.075 19.075H32.1163C33.815 19.075 35.1913 17.6986 35.1913 16C35.1913 14.3013 33.815 12.925 32.1163 12.925Z"
                          fill="#45CAFE"
                        />
                        <path
                          d="M20.5 25.225H3.075C1.37634 25.225 0 26.6013 0 28.3C0 29.9986 1.37634 31.375 3.075 31.375H20.5C22.1987 31.375 23.575 29.9986 23.575 28.3C23.575 26.6013 22.1987 25.225 20.5 25.225Z"
                          fill="#45CAFE"
                        />
                      </svg>
                    </Link>
                  )}
                  {props.showLeftSidebar && (
                    <Link
                      onClick={() => {
                        props.setShowLeftSidebar(false);
                      }}
                      className="bar_icon_close"
                    >
                      <img
                        alt=""
                        className="minimizeSidebar"
                        src={
                          require("../assets/images/common/minimize-sidebar-icon.png")
                            .default
                        }
                      />
                    </Link>
                  )}
                </div>
                <div className="d-none d-md-inline-block item">
                  <SearchBox {...props} />
                </div>
              </div>

              <div className="logo">
                <Link
                  onClick={() => {
                    props.setSelectedProviders([]);
                  }}
                  to="/"
                >
                  <svg
                    width="104"
                    height="66"
                    viewBox="0 0 104 66"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_400_4559)">
                      <path
                        d="M99.6674 0H70.3912C69.7893 0 69.212 0.239111 68.7864 0.664729C68.3608 1.09035 68.1217 1.66761 68.1217 2.26953V6.01321C68.1217 6.61513 68.3608 7.19239 68.7864 7.61801C69.212 8.04362 69.7893 8.28273 70.3912 8.28273H85.2913C85.6889 8.28273 86.0796 8.38719 86.4241 8.58565C86.7687 8.78411 87.055 9.0696 87.2545 9.41355C87.454 9.75749 87.5596 10.1478 87.5608 10.5454C87.562 10.943 87.4588 11.334 87.2613 11.6791L66.7937 47.4674C66.5962 47.8126 66.493 48.2035 66.4942 48.6011C66.4953 48.9988 66.601 49.3891 66.8005 49.733C67 50.077 67.2863 50.3625 67.6309 50.5609C67.9754 50.7594 68.3661 50.8638 68.7637 50.8638H100.946C101.548 50.8638 102.125 50.6247 102.551 50.1991C102.977 49.7735 103.216 49.1962 103.216 48.5943V44.8506C103.216 44.2487 102.977 43.6714 102.551 43.2458C102.125 42.8202 101.548 42.5811 100.946 42.5811H83.1432C82.7455 42.5813 82.3547 42.4769 82.01 42.2786C81.6653 42.0802 81.3788 41.7947 81.1792 41.4507C80.9796 41.1068 80.8739 40.7164 80.8726 40.3187C80.8714 39.921 80.9747 39.5299 81.1721 39.1847L101.638 3.39638C101.836 3.05124 101.939 2.66029 101.938 2.26268C101.937 1.86507 101.831 1.47476 101.632 1.13081C101.432 0.786873 101.146 0.501379 100.801 0.30292C100.457 0.10446 100.066 -8.93827e-07 99.6684 0"
                        fill="url(#paint0_linear_400_4559)"
                      />
                      <path
                        d="M58.6989 50.8638H2.68945C2.08775 50.8631 1.51092 50.6238 1.08545 50.1983C0.659994 49.7728 0.42065 49.196 0.419922 48.5943L0.419922 14.5924C0.42065 13.9907 0.659994 13.4138 1.08545 12.9884C1.51092 12.5629 2.08775 12.3236 2.68945 12.3228H78.1439C78.5418 12.3205 78.9332 12.4238 79.2781 12.6223C79.6229 12.8207 79.9089 13.1072 80.1067 13.4524C80.3086 13.7958 80.4157 14.1865 80.417 14.5848C80.4183 14.9831 80.3139 15.3745 80.1143 15.7192L66.7863 39.0252C66.7796 39.0245 66.773 39.023 66.7667 39.0207C66.7599 39.0181 66.7527 39.0166 66.7454 39.0162H59.3457C59.147 39.0162 58.9517 38.964 58.7795 38.8648C58.6073 38.7656 58.4641 38.6229 58.3644 38.451C58.2646 38.2791 58.2118 38.084 58.2111 37.8853C58.2104 37.6866 58.262 37.4911 58.3606 37.3185L67.0669 22.0938C67.1655 21.9213 67.2171 21.7258 67.2164 21.5271C67.2157 21.3283 67.1629 21.1332 67.0631 20.9614C66.9634 20.7895 66.8202 20.6468 66.648 20.5476C66.4758 20.4484 66.2805 20.3962 66.0818 20.3961H53.6681C53.3672 20.3961 53.0786 20.5157 52.8657 20.7285C52.6529 20.9413 52.5334 21.23 52.5334 21.5309V22.8837C52.5334 23.1846 52.6529 23.4733 52.8657 23.6861C53.0786 23.8989 53.3672 24.0184 53.6681 24.0184H59.7962C59.9949 24.0185 60.1902 24.0707 60.3624 24.1699C60.5346 24.2691 60.6778 24.4118 60.7776 24.5836C60.8773 24.7555 60.9302 24.9506 60.9308 25.1494C60.9315 25.3481 60.88 25.5436 60.7814 25.7161L52.0747 40.9412C51.9761 41.1138 51.9245 41.3092 51.9252 41.5079C51.9259 41.7067 51.9787 41.9018 52.0785 42.0737C52.1782 42.2456 52.3214 42.3882 52.4936 42.4874C52.6658 42.5866 52.8611 42.6388 53.0598 42.6389H64.72L60.67 49.7225C60.4708 50.0693 60.1838 50.3574 59.8377 50.5578C59.4916 50.7582 59.0988 50.8638 58.6989 50.8638ZM14.4267 42.6385H15.34V43.9882C15.34 44.353 15.4849 44.7029 15.7429 44.9608C16.0008 45.2188 16.3507 45.3637 16.7155 45.3637H17.1625C17.5273 45.3637 17.8771 45.2188 18.1351 44.9608C18.393 44.7029 18.538 44.353 18.538 43.9882V42.6196C20.4433 42.5144 21.9921 41.9625 23.1417 40.9783C24.4277 39.878 25.08 38.3075 25.08 36.3155C25.08 34.6491 24.6364 33.2915 23.7613 32.2802C23.3773 31.8435 22.9251 31.4719 22.4223 31.1798C22.2707 31.0889 22.1408 30.9659 22.0416 30.8196C21.9424 30.6733 21.8764 30.507 21.848 30.3325C21.8206 30.1768 21.8286 30.0168 21.8713 29.8645C21.9139 29.7122 21.9902 29.5715 22.0946 29.4526C22.2118 29.3194 22.3201 29.1787 22.4188 29.0313C23.0337 28.0563 23.3411 26.9187 23.3009 25.7667C23.3009 24.0284 22.7744 22.6839 21.7359 21.7709C20.8201 21.0375 19.707 20.5927 18.538 20.4931V18.8694C18.5375 18.5047 18.3924 18.1551 18.1346 17.8973C17.8767 17.6394 17.5271 17.4944 17.1625 17.4939H16.7155C16.3507 17.4939 16.0008 17.6388 15.7429 17.8968C15.4849 18.1547 15.34 18.5046 15.34 18.8694V20.3961H14.4267V18.8694C14.4262 18.5047 14.2812 18.1551 14.0233 17.8973C13.7655 17.6394 13.4159 17.4944 13.0512 17.4939H12.6042C12.2394 17.4939 11.8895 17.6388 11.6316 17.8968C11.3736 18.1547 11.2287 18.5046 11.2287 18.8694V20.3961H9.69024C9.38929 20.3961 9.10066 20.5157 8.88785 20.7285C8.67504 20.9413 8.55548 21.23 8.55548 21.5309V41.5038C8.55548 41.8047 8.67504 42.0933 8.88785 42.3062C9.10066 42.519 9.38929 42.6385 9.69024 42.6385H11.2301V43.9882C11.2301 44.353 11.375 44.7029 11.6329 44.9608C11.8909 45.2188 12.2408 45.3637 12.6056 45.3637H13.0526C13.4174 45.3637 13.7672 45.2188 14.0252 44.9608C14.2831 44.7029 14.4281 44.353 14.4281 43.9882V42.6389L14.4267 42.6385ZM45.469 20.3958C45.168 20.3958 44.8794 20.5154 44.6666 20.7282C44.4538 20.941 44.3342 21.2296 44.3342 21.5306V41.5038C44.3342 41.8047 44.4538 42.0933 44.6666 42.3062C44.8794 42.519 45.168 42.6385 45.469 42.6385H47.2667C47.5677 42.6385 47.8563 42.519 48.0691 42.3062C48.2819 42.0933 48.4015 41.8047 48.4015 41.5038V21.5309C48.4015 21.23 48.2819 20.9413 48.0691 20.7285C47.8563 20.5157 47.5677 20.3961 47.2667 20.3961L45.469 20.3958ZM29.5823 20.3958C29.2813 20.3958 28.9927 20.5154 28.7799 20.7282C28.5671 20.941 28.4475 21.2296 28.4475 21.5306V41.5038C28.4475 41.8047 28.5671 42.0933 28.7799 42.3062C28.9927 42.519 29.2813 42.6385 29.5823 42.6385H40.531C40.832 42.6385 41.1206 42.519 41.3334 42.3062C41.5462 42.0933 41.6658 41.8047 41.6658 41.5038V40.151C41.6658 39.85 41.5462 39.5614 41.3334 39.3486C41.1206 39.1358 40.832 39.0162 40.531 39.0162H33.6485C33.3476 39.0162 33.0589 38.8967 32.8461 38.6839C32.6333 38.471 32.5138 38.1824 32.5138 37.8815V21.5309C32.5138 21.23 32.3942 20.9413 32.1814 20.7285C31.9686 20.5157 31.68 20.3961 31.379 20.3961L29.5823 20.3958ZM17.2299 39.0162H13.7568C13.4559 39.0162 13.1672 38.8967 12.9544 38.6839C12.7416 38.471 12.6221 38.1824 12.6221 37.8815V33.8926C12.6221 33.5916 12.7416 33.303 12.9544 33.0902C13.1672 32.8774 13.4559 32.7578 13.7568 32.7578H17.2299C18.1422 32.727 19.0449 32.9526 19.8354 33.4091C20.5314 33.842 20.8842 34.6708 20.8842 35.8719C20.8842 37.0524 20.5499 37.8811 19.8911 38.3343C19.0932 38.8251 18.1654 39.0628 17.2299 39.0162ZM16.341 29.1342H13.7575C13.4566 29.1342 13.1679 29.0146 12.9551 28.8018C12.7423 28.589 12.6227 28.3004 12.6227 27.9994V25.1532C12.6227 24.8523 12.7423 24.5636 12.9551 24.3508C13.1679 24.138 13.4566 24.0184 13.7575 24.0184H16.341C17.3217 24.0184 18.0672 24.2189 18.5576 24.6144C19.0479 25.0098 19.2962 25.6752 19.2962 26.5923C19.2962 27.4774 19.0476 28.1294 18.5576 28.5307C18.0675 28.932 17.321 29.1342 16.341 29.1342Z"
                        fill="url(#paint1_linear_400_4559)"
                      />
                      <path
                        d="M92.927 65.0408C91.8579 64.8527 91.2359 64.448 90.8745 63.7403C90.499 63.0326 90.412 62.3235 90.412 60.2132C90.412 58.5953 90.4408 58.1899 90.6152 57.5404C90.8903 56.5129 91.4528 55.9644 92.5374 55.646C93.3469 55.4146 94.2289 55.3575 96.7718 55.3575C99.5468 55.3575 100.4 55.3853 101.08 55.5016C102.569 55.7767 103.292 56.5418 103.494 58.0885C103.569 58.8667 103.597 59.6486 103.58 60.4302C103.58 62.7568 103.334 63.697 102.511 64.3757C101.932 64.8675 101.123 65.0979 99.7211 65.157C99.2005 65.1849 97.9141 65.2 96.975 65.2C94.6763 65.2003 93.5057 65.1577 92.927 65.0408ZM93.8812 58.0603C93.492 58.3636 93.3757 58.8415 93.3757 60.2291C93.3757 61.6454 93.4916 62.165 93.852 62.4683C94.2426 62.7867 94.7192 62.8466 96.932 62.8466C99.4608 62.8466 99.9818 62.7592 100.314 62.2964C100.589 61.9501 100.66 61.4587 100.66 60.172C100.66 57.7439 100.617 57.715 97.0039 57.715C94.8492 57.7133 94.2578 57.7855 93.8812 58.0596V58.0603ZM1.70242 64.5343C0.749215 63.9277 0.474121 62.9167 0.474121 60.054C0.474121 57.5101 0.763657 56.6002 1.77566 56.0222C2.64255 55.5157 3.56893 55.3857 6.27001 55.3857C9.86927 55.3857 10.6502 55.4575 11.4731 55.8619C12.254 56.2515 12.6154 57.1054 12.6154 58.5211V58.8381H9.81115C9.75304 57.7842 9.53606 57.6972 6.99144 57.6972C4.59159 57.6972 4.15935 57.7549 3.79657 58.0733C3.45029 58.3904 3.37808 58.781 3.37808 60.3429C3.37808 62.6561 3.59437 62.829 6.41374 62.829C8.59627 62.829 8.91366 62.8139 9.31805 62.642C9.73757 62.4673 9.89678 62.164 9.89678 61.4704H12.7467C12.7302 62.872 12.6873 63.3496 12.4854 63.7833C12.1099 64.6085 11.329 64.9968 9.82628 65.0989C9.23346 65.156 8.07703 65.1711 6.15481 65.1711C3.37946 65.1711 2.48368 65.0408 1.70242 64.5343ZM40.8472 64.6646C40.2544 64.3754 39.9511 63.6385 39.9511 62.4982C39.9511 62.4109 39.9511 62.2231 39.9652 62.0206H42.842C42.8709 62.6853 42.9428 62.8459 43.2891 62.9748C43.9366 63.097 44.5958 63.1454 45.2543 63.1189C48.6513 63.1189 49.0561 63.0182 49.0561 62.2228C49.07 62.057 49.0296 61.8912 48.9409 61.7505C48.8521 61.6097 48.7199 61.5018 48.5643 61.4429C48.2459 61.3422 48.2459 61.3422 46.7294 61.327H44.0693C42.2922 61.327 41.5542 61.2259 40.9325 60.9085C40.24 60.5471 39.9216 59.781 39.9216 58.4671C39.9216 56.7323 40.4133 55.9954 41.7998 55.6628C42.5807 55.4603 43.7079 55.3877 45.8185 55.3877C49.2001 55.3877 49.9814 55.4734 50.6753 55.9221C51.34 56.3691 51.556 56.9623 51.556 58.4083H48.695C48.695 57.5703 48.4055 57.4537 46.5121 57.4537C45.573 57.4537 44.3145 57.4829 43.8523 57.5118C43.0724 57.5699 42.8121 57.7721 42.8121 58.3209C42.7998 58.5036 42.857 58.6842 42.9724 58.8265C43.0877 58.9687 43.2525 59.062 43.4338 59.0878C43.8244 59.1612 44.2226 59.1854 44.6191 59.16H47.3501C47.6104 59.16 48.9109 59.203 49.4027 59.2322C51.2389 59.3181 51.9617 60.128 51.9617 62.0646C51.9617 63.8424 51.4411 64.6237 50.0244 64.927C49.3023 65.0862 47.8707 65.1721 45.7756 65.1721C42.4373 65.1697 41.7004 65.0979 40.8476 64.6646H40.8472ZM78.3288 65.0986L72.5759 57.843L72.6481 65.0986H69.8284V55.4582H74.4971L80.3363 62.785L80.2641 55.4582H83.0394V65.0986H78.3288ZM59.3061 65.0986V55.4575H62.2392V65.0979L59.3061 65.0986ZM30.4105 65.0986L29.4563 63.3792H23.2402L22.3162 65.0986H18.9914L24.4114 55.4575H28.3432L33.6185 65.0979L30.4105 65.0986ZM24.2955 61.3693H28.4305L26.3481 57.5238L24.2955 61.3693Z"
                        fill="#264EF8"
                      />
                    </g>
                    <defs>
                      <linearGradient
                        id="paint0_linear_400_4559"
                        x1="100.719"
                        y1="50.8638"
                        x2="70.6453"
                        y2="24.5948"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#264EF8" />
                        <stop offset="1" stop-color="#4DE8FF" />
                      </linearGradient>
                      <linearGradient
                        id="paint1_linear_400_4559"
                        x1="0.419924"
                        y1="50.8638"
                        x2="30.4146"
                        y2="-10.3828"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#264EF8" />
                        <stop offset="1" stop-color="#4DE8FF" />
                      </linearGradient>
                      <clipPath id="clip0_400_4559">
                        <rect
                          width="103.16"
                          height="65.2"
                          fill="white"
                          transform="translate(0.419922)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </Link>
              </div>

              <div className="login_buttons_and_wallet">
                {isAuthenticated ? (
                  <>
                    <div className="d-md-inline-block item">
                      <CashierModals {...props} />
                    </div>
                    <div className="d-none d-lg-inline-block item">
                      <Link
                        onClick={() => props.setIsChatVisible(true)}
                        className="search_btn"
                      >
                        <svg
                          style={{ marginTop: "10px" }}
                          width="26"
                          height="23"
                          viewBox="0 0 26 23"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.2539 12.9492C13.6746 12.9492 14.0156 12.6082 14.0156 12.1875C14.0156 11.7668 13.6746 11.4258 13.2539 11.4258C12.8332 11.4258 12.4922 11.7668 12.4922 12.1875C12.4922 12.6082 12.8332 12.9492 13.2539 12.9492Z"
                            fill="#10294F"
                          />
                          <path
                            d="M16.3005 12.9492C16.7212 12.9492 17.0623 12.6082 17.0623 12.1875C17.0623 11.7668 16.7212 11.4258 16.3005 11.4258C15.8799 11.4258 15.5388 11.7668 15.5388 12.1875C15.5388 12.6082 15.8799 12.9492 16.3005 12.9492Z"
                            fill="#10294F"
                          />
                          <path
                            d="M19.3474 12.9492C19.7681 12.9492 20.1091 12.6082 20.1091 12.1875C20.1091 11.7668 19.7681 11.4258 19.3474 11.4258C18.9267 11.4258 18.5857 11.7668 18.5857 12.1875C18.5857 12.6082 18.9267 12.9492 19.3474 12.9492Z"
                            fill="#10294F"
                          />
                          <path
                            d="M24.3776 17.2017C26.8901 13.6766 26.506 8.84706 23.0743 5.70111C21.5064 4.26375 19.5075 3.36893 17.3482 3.11903C17.3347 3.10248 17.321 3.08608 17.3059 3.07039C15.4274 1.11912 12.7287 0 9.90173 0C4.52202 0 0 4.00832 0 9.14062C0 10.9401 0.558949 12.665 1.62073 14.1548L0.137465 18.8118C0.0442305 19.1045 0.135941 19.4244 0.369992 19.6233C0.604449 19.8226 0.935187 19.8609 1.20844 19.7219L5.71919 17.4283C6.64554 17.8272 7.62785 18.0889 8.6451 18.208C10.6074 20.2715 13.3207 21.3281 16.0966 21.3281C17.5396 21.3281 18.9774 21.034 20.279 20.4751L24.7899 22.7688C24.8992 22.8244 25.0174 22.8516 25.135 22.8516C25.649 22.8516 26.0176 22.3506 25.8609 21.8586L24.3776 17.2017ZM6.02662 15.8956C5.81328 15.7943 5.56512 15.7976 5.35463 15.9047L2.14185 17.5383L3.19099 14.2443C3.26737 14.0045 3.22039 13.7425 3.06541 13.5442C2.05659 12.2528 1.52334 10.7301 1.52334 9.14062C1.52334 4.94051 5.28186 1.52344 9.90173 1.52344C11.7622 1.52344 13.5532 2.08706 15.006 3.10202C10.1133 3.59399 6.1949 7.41548 6.1949 12.1875C6.1949 13.6717 6.57536 15.1006 7.29264 16.3808C6.85836 16.2515 6.4354 16.0897 6.02662 15.8956ZM20.6437 18.9515C20.4363 18.846 20.1879 18.8397 19.9718 18.9425C18.7842 19.5065 17.4443 19.8047 16.0966 19.8047C11.4768 19.8047 7.71824 16.3876 7.71824 12.1875C7.71824 7.98738 11.4768 4.57031 16.0966 4.57031C20.7165 4.57031 24.475 7.98738 24.475 12.1875C24.475 13.777 23.9418 15.2997 22.9329 16.591C22.778 16.7893 22.731 17.0513 22.8073 17.2912L23.8565 20.5851L20.6437 18.9515Z"
                            fill="#10294F"
                          />
                        </svg>
                      </Link>
                    </div>
                    <div className="d-none d-lg-inline-block  item">
                      {/* <Link
                        onClick={() => {
                          props.setShowLeftSidebar(true);
                        }}
                        className="common_btn_v1 inactive font_regular padding_0_8"
                        style={{ fontSize: fontSize + "px" }}
                      >
                        {props.userDetails.username && props.userDetails.username !== ""
                          ? props.userDetails.username
                          : props.userDetails.first_name}
                      </Link> */}
                      <UserDropDownMenu {...props} fontSize={fontSize} />
                    </div>
                  </>
                ) : (
                  <>
                    <div className="d-inline-block item d-none">
                      <Link
                        onClick={() => {
                          props.setModalLoginPropsData(true);
                          setTimeout(function () {
                            props.setModalLoginPropsData(false);
                          }, 500);
                        }}
                        to="#"
                        className="user_icon"
                      >
                        <svg
                          width="22"
                          height="30"
                          viewBox="0 0 22 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10.8139 0.715668C5.0153 0.715668 0.313477 5.41657 0.313477 11.2157C0.313477 17.0148 5.01484 21.7157 10.8139 21.7157C16.6135 21.7157 21.3144 17.0148 21.3144 11.2157C21.3144 5.41657 16.6135 0.715668 10.8139 0.715668ZM10.8139 3.85529C12.7327 3.85529 14.2875 5.41057 14.2875 7.32838C14.2875 9.24666 12.7327 10.8015 10.8139 10.8015C8.89613 10.8015 7.3413 9.24666 7.3413 7.32838C7.3413 5.41057 8.89613 3.85529 10.8139 3.85529ZM10.8116 18.9704C8.89797 18.9704 7.14528 18.2735 5.7934 17.1199C5.46408 16.839 5.27405 16.4272 5.27405 15.995C5.27405 14.05 6.84824 12.4933 8.79373 12.4933H12.8351C14.781 12.4933 16.3492 14.05 16.3492 15.995C16.3492 16.4276 16.1601 16.8386 15.8303 17.1195C14.4789 18.2735 12.7258 18.9704 10.8116 18.9704Z"
                            fill="#4DE8FF"
                          />
                        </svg>
                      </Link>
                    </div>
                    <div
                      className=" d-md-inline-block item"
                      style={{ position: "relative" }}
                    >
                      <Link
                        onClick={() => {
                          props.setModalLoginPropsData(true);
                          setTimeout(function () {
                            props.setModalLoginPropsData(false);
                          }, 500);
                        }}
                        className="common_btn_v1 inactive login_btn font_regular"
                      >
                        {__("Log In")}
                      </Link>
                      {/* <img
                        style={{ width: 35, position: "absolute", right: "-7px", top: "-11px" }}
                        src={require("assets/images/gifts/holidays.gif").default}
                      /> */}
                    </div>
                    <div className=" item">
                      <Link
                        onClick={() => {
                          props.setModalSignUpPropsData(true);
                          setTimeout(function () {
                            props.setModalSignUpPropsData(false);
                          }, 500);
                        }}
                        className="common_btn_v1 login_btn font_regular"
                      >
                        {__("Register")}
                      </Link>
                    </div>
                  </>
                )}

                <div className="language_switch item d-none d-md-inline-block">
                  <LanguageSwitcher />
                </div>
              </div>
              <div className="d-md-none col-4 text-right mobile_menu_icon">
                <div className="item d-md-none">
                  {!props.showLeftSidebar && (
                    <Link
                      onClick={() => {
                        props.setShowLeftSidebar(true);
                      }}
                      className="bar_icon"
                    >
                      <svg
                        width="41"
                        height="32"
                        viewBox="0 0 41 45"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M37.925 0.625H3.075C1.37634 0.625 0 2.00134 0 3.7C0 5.39865 1.37634 6.775 3.075 6.775H37.925C39.6236 6.775 41 5.39865 41 3.7C41 2.00134 39.6236 0.625 37.925 0.625Z"
                          fill="#45CAFE"
                        />
                        <path
                          d="M32.1163 12.925H3.075C1.37634 12.925 0 14.3013 0 16C0 17.6986 1.37634 19.075 3.075 19.075H32.1163C33.815 19.075 35.1913 17.6986 35.1913 16C35.1913 14.3013 33.815 12.925 32.1163 12.925Z"
                          fill="#45CAFE"
                        />
                        <path
                          d="M20.5 25.225H3.075C1.37634 25.225 0 26.6013 0 28.3C0 29.9986 1.37634 31.375 3.075 31.375H20.5C22.1987 31.375 23.575 29.9986 23.575 28.3C23.575 26.6013 22.1987 25.225 20.5 25.225Z"
                          fill="#45CAFE"
                        />
                      </svg>
                    </Link>
                  )}
                  {props.showLeftSidebar && (
                    <Link
                      onClick={() => {
                        props.setShowLeftSidebar(false);
                      }}
                      className="bar_icon_close"
                    >
                      <img
                        alt=""
                        className="minimizeSidebar"
                        src={
                          require("../assets/images/common/minimize-sidebar-icon.png")
                            .default
                        }
                      />
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* end version1 */}
      </header>

      <RightSidebar
        userBalance={props.userBalance}
        userDetails={props.userDetails}
        accountProgress={props.accountProgress}
        rightSidebarOpen={rightSidebarOpen}
        toggleRightSidebar={toggleRightSidebar}
        setShowVaultModal={props.setShowVaultModal}
      />

      <VaultModals {...props} />
      <BalanceTransfer {...props} />
      <PlayerStats {...props} />
    </>
  );
};

export default Header;
